import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center pa-4" }

import { ref, watch, onUnmounted } from "vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResponseNuevoUsuario',
  props: {
  isVisible: {
    type: Boolean,
    required: true,
  },
},
  emits: ["update:isVisible"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;
const internalVisible = ref(props.isVisible);
const router = useRouter();

watch(
  () => props.isVisible,
  (newVal) => {
    internalVisible.value = newVal;
  }
);

const handlerOk = () => {
  emits("update:isVisible", false);
  internalVisible.value = false;
  router.push({ name: "inicio-sesion" });
};

const handleEscapeKey = (event: KeyboardEvent) => {
  if (event.key === "Escape") {
    internalVisible.value = false;
    emits("update:isVisible", false);
  }
};
onUnmounted(() => {
  window.removeEventListener("keydown", handleEscapeKey);
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_dialog, {
          modelValue: internalVisible.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalVisible).value = $event)),
          width: "auto",
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { "max-width": "400" }, {
              actions: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "tonal",
                  color: "blue darken-1",
                  onClick: handlerOk
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ok")
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { color: "success" }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-check-circle")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" Registro completado ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" Usuario creado con éxito ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }))
}
}

})